import { render, staticRenderFns } from "./CorSelect.vue?vue&type=template&id=78d538f4&"
import script from "./CorSelect.vue?vue&type=script&lang=js&"
export * from "./CorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports